/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import zIndexScale from '../../utils/zIndexScale';
import { getSupportLocale } from '../../utils/locales';
import urlConfig from '../../config/urls';
import FeeTip from '../OrderForms/FeeTip';
import Icon from '../Icon';

const {
  external: { aboutFee: ABOUTFEE },
  user: { index: USERCENTER },
} = urlConfig;

const Fire = styled.div`
  position: relative;
  padding: 0px 8px;
  cursor: pointer;
  .icon-huoyan {
    display: inline-block;
    margin-top: -3px;
    color: ${({ theme, commissionStatus }) => commissionStatus === 1 ? theme.bnbBurning : theme.bnbBurnClose};
  }
  .icon-warn {
    font-size: 12px;
    position: absolute;
    right: 5px;
    top: 10px;
    color: #666;
  }
`;

const TooltipContentBox = styled.div`
  position: absolute;
  left: -170%;
  bottom: -10px;
  z-index: ${zIndexScale.tooltip};
  cursor: pointer;
  transform: translate(-50%, -70%);
  & > p {
    color: ${({ theme }) => theme.fontColor};
    background: ${({ theme }) => theme.tooltipBg};
    font-size: 12px;
    padding: 10px 12px;
    box-shadow: ${({ theme }) => theme.toolTipBoxShadow};
    white-space: nowrap;
    & > a,
    a:visited {
      color: ${({ theme }) => theme.highlight};
      margin: 0 4px;
    }
  }
`;

type ComponentProps = {
  userInfo: Object,
  i18n: Object,
  locale: string,
  userAssets: Object,
};

type stateType = { shouldShowTip: boolean };

export default
@withI18n
class BnbBurningStatus extends React.Component<ComponentProps, stateType> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  state = {
    shouldShowTip: false,
  };

  _showBurnBnbTip = () => {
    this.setState({
      shouldShowTip: true,
    });
  };

  _hideBurnBnbTip = () => {
    this.setState({
      shouldShowTip: false,
    });
  };

  _renderBurnBnbTip = () => {
    const {
      userInfo, i18n, locale, userAssets,
    } = this.props;
    const { commissionStatus } = userInfo.userData || {};
    const aboutFeeLink = ABOUTFEE.replace('%locale', getSupportLocale(locale));
    const userCenterLink = USERCENTER.replace('%locale', locale);
    return (
      <TooltipContentBox>
        <p>
          <FeeTip commissionStatus={commissionStatus} i18n={i18n} bnbAmount={userAssets.BNB} />
          <a href={aboutFeeLink} target="_blank" rel="noopener noreferrer" id="BnbBurningStatus-a-details">
            {getLabel('exchange-common-details', i18n)}
          </a>{' '}
          |
          <a href={userCenterLink} target="_blank" rel="noopener noreferrer" id="BnbBurningStatus-a-set">
            {getLabel('exchange-common-set', i18n)}
          </a>
        </p>
      </TooltipContentBox>
    );
  };

  render() {
    const { userInfo, userAssets } = this.props;
    const { shouldShowTip } = this.state;
    const { commissionStatus } = userInfo.userData || {};
    return (
      <Fire
        onMouseEnter={this._showBurnBnbTip}
        onMouseLeave={this._hideBurnBnbTip}
        commissionStatus={commissionStatus}
      >
        <Icon type="huoyan" size={16} />
        {commissionStatus === 1 && userAssets.BNB < 1 ? (
          <Icon type="warn" size={16} color="#666" />
        ) : null}
        {shouldShowTip ? this._renderBurnBnbTip() : null}
      </Fire>
    );
  }
}
